import React, { useEffect, useState } from 'react';
import { useSalesData } from '../context/SalesDataContext';
import { Zap, Tag, ChevronRight } from 'lucide-react';

const OfferSection = ({ onOfferSelect }) => {
    const { offers, loadingOffers } = useSalesData();

    if (loadingOffers) return null;
    if (offers.length === 0) return null;

    return (
        <div className="flex gap-4 mb-6 overflow-x-auto pb-2 custom-scrollbar">
            {offers.map((offer) => (
                <div
                    key={offer.id}
                    onClick={() => onOfferSelect && onOfferSelect(offer)}
                    className="flex-shrink-0 w-64 bg-slate-900/60 backdrop-blur-md border border-slate-800 hover:border-primary/50 rounded-xl p-4 cursor-pointer transition-all duration-300 group relative overflow-hidden"
                >
                    <div className="absolute top-0 right-0 p-2 opacity-10 group-hover:opacity-20 transition-opacity">
                        <Tag className="w-12 h-12 text-primary" />
                    </div>

                    <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-primary/10 rounded-lg">
                            <Zap size={14} className="text-primary" />
                        </div>
                        <span className="text-[10px] font-bold uppercase tracking-widest text-primary/80">Oferta Especial</span>
                    </div>

                    <div className="mb-4">
                        <div className="flex items-baseline gap-1">
                            <span className="text-3xl font-black text-primary tracking-tighter">
                                {offer.precio ? offer.precio : '—'}
                            </span>
                            <span className="text-[10px] font-bold text-slate-500 uppercase">€/kWh</span>
                        </div>
                        <p className="text-[11px] leading-tight text-slate-300 font-medium italic mt-0.5 line-clamp-1">
                            {offer.slogan}
                        </p>
                    </div>

                    <h4 className="text-xs font-bold text-slate-400 truncate uppercase tracking-wider mb-1">
                        {offer.name}
                    </h4>

                    <div className="mt-2 flex items-center text-[9px] font-black text-primary uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-[-10px] group-hover:translate-x-0">
                        <span>Aplicar Oferta</span>
                        <ChevronRight size={10} className="ml-1" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default OfferSection;
